import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.every.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
var render = function render() {
  var _vm$actionsStore$sele, _vm$actionsStore$sele2, _vm$actionsStore$sele3, _vm$actionsStore$sele4, _vm$actionsStore$sele5, _vm$actionsStore$sele6, _vm$actionsStore$sele7, _vm$actionsStore;
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('ColumnVisibilitySidebar', {
    attrs: {
      "id": _vm.columnSidebarId,
      "module-label": "OS",
      "fields": _vm.fields,
      "visible-fields": _vm.fieldsToShow
    },
    on: {
      "save": _vm.handleSaveFields
    }
  }), _c('FilterFields', {
    attrs: {
      "fields": [{
        type: 'text',
        label: 'Número',
        field: 'numero'
      }, {
        type: 'text',
        label: 'Cliente',
        field: 'cliente'
      }, {
        type: 'text',
        label: 'Técnico',
        field: 'tecnico'
      }, {
        type: 'text',
        label: 'Objeto',
        field: 'objeto'
      }, {
        type: 'text',
        label: 'Local de Atendimento',
        field: 'local_atendimento'
      }, {
        type: 'date',
        label: 'Dt. Entrada',
        field: 'dataEntrada'
      }, {
        type: 'date',
        label: 'Dt. Saída',
        field: 'dataSaida'
      }, {
        type: 'date',
        label: 'Dt. Conclusão',
        field: 'dataConclusao'
      }, {
        type: 'text',
        label: 'Identificador',
        field: 'identificador'
      }, {
        type: 'text',
        label: 'Solicitante',
        field: 'solicitante'
      }, {
        type: 'select',
        label: 'Status',
        field: 'status',
        options: ['Todos', 'Em aberto', 'Orçada', 'Autorizada', 'Cancelada', 'Exportada (NFe/NFSe)', 'Não autorizada', 'Análise do cliente', 'Em andamento', 'Finalizada', 'Aguardando Componentes', 'Serviço Concluído', 'Finalizada sem concerto', 'Aprovado', 'Sem defeito', 'Faturada', 'Entregue aguardando faturamento']
      }]
    }
  }), _vm.actionsStore.selectedRows.length > 0 ? _c('b-dropdown', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.right",
      value: 'Mais ações',
      expression: "'Mais ações'",
      modifiers: {
        "right": true
      }
    }],
    staticClass: "mb-5",
    staticStyle: {
      "position": "absolute",
      "top": "0",
      "left": "50px"
    },
    attrs: {
      "id": "menu",
      "variant": "dark"
    },
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function fn() {
        return [_c('Menu', {
          attrs: {
            "size": 18
          }
        })];
      },
      proxy: true
    }], null, false, 2976318409)
  }, [_c('b-dropdown-item', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.duplicarOS",
      modifiers: {
        "duplicarOS": true
      }
    }],
    attrs: {
      "disabled": _vm.actionsStore.selectedRows.length > 1
    }
  }, [_vm._v(" Duplicar OS ")]), _c('b-dropdown-item', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.atualizarOS",
      modifiers: {
        "atualizarOS": true
      }
    }]
  }, [_vm._v(" Atualizar status ")]), _c('b-dropdown-item', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.comprovanteEntrega",
      modifiers: {
        "comprovanteEntrega": true
      }
    }],
    attrs: {
      "disabled": _vm.actionsStore.selectedRows.length > 1
    }
  }, [_vm._v(" Comprovante de entrega ")]), _c('b-dropdown-item', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modalEtiqueta",
      modifiers: {
        "modalEtiqueta": true
      }
    }],
    attrs: {
      "disabled": _vm.actionsStore.selectedRows.length > 1
    }
  }, [_vm._v(" Etiqueta ")]), !_vm.store.pafNFCe && ((_vm$actionsStore$sele = _vm.actionsStore.selectedRows[0]) === null || _vm$actionsStore$sele === void 0 ? void 0 : _vm$actionsStore$sele.status) != 5 ? _c('b-dropdown-item', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.faturarOS",
      modifiers: {
        "faturarOS": true
      }
    }],
    attrs: {
      "disabled": _vm.actionsStore.selectedRows.every(function (o) {
        return o.status == 14;
      })
    }
  }, [_vm._v(" Faturar OS ")]) : _vm._e(), _c('b-dropdown-item', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.copiaArquivo",
      modifiers: {
        "copiaArquivo": true
      }
    }],
    attrs: {
      "disabled": _vm.actionsStore.selectedRows.length > 1
    }
  }, [_vm._v(" Anexar cópia ")]), _c('b-dropdown-item', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.dataBaixa",
      modifiers: {
        "dataBaixa": true
      }
    }],
    attrs: {
      "disabled": _vm.actionsStore.selectedRows.length > 1
    }
  }, [_vm._v(" Data de saída ")]), ((_vm$actionsStore$sele2 = _vm.actionsStore.selectedRows[0]) === null || _vm$actionsStore$sele2 === void 0 ? void 0 : _vm$actionsStore$sele2.status) == 14 ? _c('b-dropdown-item', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.estornarOSModal",
      modifiers: {
        "estornarOSModal": true
      }
    }],
    attrs: {
      "disabled": _vm.actionsStore.selectedRows.length <= 0
    }
  }, [_vm._v(" Estornar OS ")]) : _vm._e()], 1) : _vm._e(), _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.right",
      value: 'Customizar colunas',
      expression: "'Customizar colunas'",
      modifiers: {
        "hover": true,
        "right": true
      }
    }],
    staticClass: "border border-muted",
    staticStyle: {
      "position": "absolute",
      "right": "0",
      "top": "0"
    },
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": function click($event) {
        return _vm.$root.$emit('bv::toggle::collapse', _vm.columnSidebarId);
      }
    }
  }, [_c('ToggleSwitchOutline', {
    attrs: {
      "size": 20
    }
  })], 1), _c('b-modal', {
    attrs: {
      "id": "dataBaixa",
      "title": "Deseja atualizar a data de saída na OS?",
      "centered": "",
      "size": "xs"
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref) {
        var ok = _ref.ok,
          cancel = _ref.cancel;
        return [_c('div', [_c('b-button', {
          ref: "dataSaidaButton",
          staticClass: "mr-5",
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": _vm.updateDataSaida
          }
        }, [_vm._v(" Confirmar ")]), _c('b-button', {
          on: {
            "click": function click($event) {
              {
                _vm.actionsStore.updateTable = !_vm.actionsStore.updateTable;
                _vm.actionsStore.selectedRows = [];
                cancel();
              }
            }
          }
        }, [_vm._v(" Cancelar ")])], 1)];
      }
    }])
  }, [_c('label', [_c('p', [_vm._v(" Informe a data de saída da OS: " + _vm._s((_vm$actionsStore$sele3 = _vm.actionsStore.selectedRows[0]) === null || _vm$actionsStore$sele3 === void 0 ? void 0 : _vm$actionsStore$sele3.numero) + " ")])]), _c('b-row', [_c('b-col', {
    attrs: {
      "sm": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "dataConclusao",
      "label-for": "dataConclusao",
      "label": "Data de conclusão"
    }
  }, [_c('b-form-datepicker', {
    attrs: {
      "locale": "pt-br",
      "date-format-options": {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric'
      }
    },
    model: {
      value: _vm.dataSaida,
      callback: function callback($$v) {
        _vm.dataSaida = $$v;
      },
      expression: "dataSaida"
    }
  })], 1)], 1)], 1)], 1), _c('b-modal', {
    attrs: {
      "id": "copiaArquivo",
      "title": "Deseja anexar cópia?",
      "centered": "",
      "size": "xs"
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref2) {
        var ok = _ref2.ok,
          cancel = _ref2.cancel;
        return [_c('div', [_c('b-button', {
          ref: "copiaAnexo",
          staticClass: "mr-5",
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": _vm.anexarCopia
          }
        }, [_vm._v(" Confirmar ")]), _c('b-button', {
          on: {
            "click": function click($event) {
              {
                _vm.actionsStore.updateTable = !_vm.actionsStore.updateTable;
                _vm.actionsStore.selectedRows = [];
                cancel();
              }
            }
          }
        }, [_vm._v(" Cancelar ")])], 1)];
      }
    }])
  }, [_c('label', [_c('p', [_vm._v(" Inserir cópia da OS número: " + _vm._s((_vm$actionsStore$sele4 = _vm.actionsStore.selectedRows[0]) === null || _vm$actionsStore$sele4 === void 0 ? void 0 : _vm$actionsStore$sele4.numero) + " ")])]), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('input', {
    attrs: {
      "id": "fileUpload",
      "type": "file",
      "accept": ".jpg, .png, .pdf"
    },
    on: {
      "change": _vm.setAnexoCopia
    }
  })])], 1)], 1), _c('b-modal', {
    attrs: {
      "id": "comprovanteEntrega",
      "title": "Deseja imprimir o comprovante de entrega do Objeto?",
      "centered": "",
      "size": "xs"
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref3) {
        var ok = _ref3.ok,
          cancel = _ref3.cancel;
        return [_c('div', [_c('b-button', {
          ref: "comprovanteEntrega",
          staticClass: "mr-5",
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": _vm.imprimirComprovante
          }
        }, [_vm._v(" Confirmar ")]), _c('b-button', {
          on: {
            "click": function click($event) {
              {
                _vm.actionsStore.updateTable = !_vm.actionsStore.updateTable;
                _vm.actionsStore.selectedRows = [];
                cancel();
              }
            }
          }
        }, [_vm._v(" Cancelar ")])], 1)];
      }
    }])
  }, [_c('label', [_c('p', [_vm._v(" OS a ser impressa número: " + _vm._s((_vm$actionsStore$sele5 = _vm.actionsStore.selectedRows[0]) === null || _vm$actionsStore$sele5 === void 0 ? void 0 : _vm$actionsStore$sele5.numero) + " ")])])]), _c('b-modal', {
    attrs: {
      "id": "faturarOS",
      "title": _vm.actionsStore.selectedRows.length > 1 ? 'Deseja faturar as ' + _vm.actionsStore.selectedRows.length + ' OS selecionadas?' : 'Deseja faturar a OS?',
      "centered": "",
      "size": "lg",
      "scrollable": ""
    },
    on: {
      "show": _vm.inicializarItensFaturamento
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref4) {
        var cancel = _ref4.cancel;
        return [_c('div', [_c('b-button', {
          ref: "faturarOrdemServico",
          staticClass: "mr-5",
          attrs: {
            "variant": "primary",
            "disabled": _vm.permitido_faturar
          },
          on: {
            "click": _vm.faturarOrdemServico
          }
        }, [_vm._v(" Confirmar ")]), _c('b-button', {
          on: {
            "click": function click($event) {
              {
                _vm.actionsStore.updateTable = !_vm.actionsStore.updateTable;
                _vm.actionsStore.selectedRows = [];
                cancel();
              }
            }
          }
        }, [_vm._v(" Cancelar ")])], 1)];
      }
    }])
  }, [_c('h6', {
    staticClass: "font-weight-bolder text-dark"
  }, [_vm._v(" Configuração geral (aplica-se a todos) ")]), _c('b-row', {
    staticClass: "align-items-center mb-3"
  }, [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('p', {
    staticClass: "font-weight-bolder text-dark mb-2"
  }, [_vm._v("Movimentar estoque")]), _c('span', {
    staticClass: "switch switch-icon"
  }, [_c('label', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.right",
      value: 'Não/Sim',
      expression: "'Não/Sim'",
      modifiers: {
        "hover": true,
        "right": true
      }
    }]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.movimentar_estoque,
      expression: "movimentar_estoque"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.movimentar_estoque) ? _vm._i(_vm.movimentar_estoque, null) > -1 : _vm.movimentar_estoque
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.movimentar_estoque,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.movimentar_estoque = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.movimentar_estoque = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.movimentar_estoque = $$c;
        }
      }
    }
  }), _c('span')])])]), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('p', {
    staticClass: "font-weight-bolder text-dark mb-2"
  }, [_vm._v("Gerar financeiro")]), _c('span', {
    staticClass: "switch switch-icon"
  }, [_c('label', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.right",
      value: 'Não/Sim',
      expression: "'Não/Sim'",
      modifiers: {
        "hover": true,
        "right": true
      }
    }]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.gerar_financeiro,
      expression: "gerar_financeiro"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.gerar_financeiro) ? _vm._i(_vm.gerar_financeiro, null) > -1 : _vm.gerar_financeiro
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.gerar_financeiro,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.gerar_financeiro = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.gerar_financeiro = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.gerar_financeiro = $$c;
        }
      }
    }
  }), _c('span')])])]), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "data_faturamento_global",
      "label-for": "data_faturamento_global",
      "label": "Data do Faturamento"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date",
      "required": ""
    },
    model: {
      value: _vm.data_faturamento,
      callback: function callback($$v) {
        _vm.data_faturamento = $$v;
      },
      expression: "data_faturamento"
    }
  })], 1)], 1), _c('b-col', {
    staticClass: "text-right",
    attrs: {
      "md": "12"
    }
  }, [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.aplicarGlobalAosItens
    }
  }, [_vm._v(" Aplicar a todos ")])], 1)], 1), _c('hr'), _c('h6', {
    staticClass: "font-weight-bolder text-dark mb-2"
  }, [_vm._v(" OS selecionadas (" + _vm._s(_vm.itensFaturamento.length) + ") ")]), _c('div', {
    staticStyle: {
      "max-height": "320px",
      "overflow-y": "auto"
    }
  }, [_c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "bordered": "",
      "small": "",
      "items": _vm.itensFaturamento,
      "fields": _vm.camposItensFaturamento,
      "responsive": ""
    },
    scopedSlots: _vm._u([{
      key: "cell(numero)",
      fn: function fn(row) {
        return [_c('strong', [_vm._v(_vm._s(row.item.numero))])];
      }
    }, {
      key: "cell(movimentar_estoque)",
      fn: function fn(row) {
        return [_c('span', {
          staticClass: "switch switch-icon"
        }, [_c('label', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.right",
            value: 'Não/Sim',
            expression: "'Não/Sim'",
            modifiers: {
              "hover": true,
              "right": true
            }
          }]
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: row.item.movimentar_estoque,
            expression: "row.item.movimentar_estoque"
          }],
          attrs: {
            "type": "checkbox"
          },
          domProps: {
            "checked": Array.isArray(row.item.movimentar_estoque) ? _vm._i(row.item.movimentar_estoque, null) > -1 : row.item.movimentar_estoque
          },
          on: {
            "change": function change($event) {
              var $$a = row.item.movimentar_estoque,
                $$el = $event.target,
                $$c = $$el.checked ? true : false;
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v);
                if ($$el.checked) {
                  $$i < 0 && _vm.$set(row.item, "movimentar_estoque", $$a.concat([$$v]));
                } else {
                  $$i > -1 && _vm.$set(row.item, "movimentar_estoque", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
                }
              } else {
                _vm.$set(row.item, "movimentar_estoque", $$c);
              }
            }
          }
        }), _c('span')])])];
      }
    }, {
      key: "cell(gerar_financeiro)",
      fn: function fn(row) {
        return [_c('span', {
          staticClass: "switch switch-icon"
        }, [_c('label', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.right",
            value: 'Não/Sim',
            expression: "'Não/Sim'",
            modifiers: {
              "hover": true,
              "right": true
            }
          }]
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: row.item.gerar_financeiro,
            expression: "row.item.gerar_financeiro"
          }],
          attrs: {
            "type": "checkbox"
          },
          domProps: {
            "checked": Array.isArray(row.item.gerar_financeiro) ? _vm._i(row.item.gerar_financeiro, null) > -1 : row.item.gerar_financeiro
          },
          on: {
            "change": function change($event) {
              var $$a = row.item.gerar_financeiro,
                $$el = $event.target,
                $$c = $$el.checked ? true : false;
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v);
                if ($$el.checked) {
                  $$i < 0 && _vm.$set(row.item, "gerar_financeiro", $$a.concat([$$v]));
                } else {
                  $$i > -1 && _vm.$set(row.item, "gerar_financeiro", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
                }
              } else {
                _vm.$set(row.item, "gerar_financeiro", $$c);
              }
            }
          }
        }), _c('span')])])];
      }
    }, {
      key: "head(comprovante_pagamento)",
      fn: function fn() {
        return [_vm._v(" Comprovante "), _c('span', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.bottom",
            value: 'PDF, JPG/JPEG ou PNG de até 10 MB. O arquivo será anexado às parcelas desta OS no Contas a Receber.',
            expression: "'PDF, JPG/JPEG ou PNG de até 10 MB. O arquivo será anexado às parcelas desta OS no Contas a Receber.'",
            modifiers: {
              "hover": true,
              "bottom": true
            }
          }],
          staticClass: "ml-1 text-primary cursor-pointer"
        }, [_c('InformationOutline', {
          attrs: {
            "size": 16
          }
        })], 1)];
      },
      proxy: true
    }, {
      key: "cell(comprovante_pagamento)",
      fn: function fn(row) {
        return [row.item.gerar_financeiro ? _c('input', {
          staticClass: "form-control-file",
          attrs: {
            "type": "file",
            "accept": "application/pdf,image/jpeg,image/png,.pdf,.jpg,.jpeg,.png"
          },
          on: {
            "change": function change($event) {
              row.item.comprovante_pagamento = $event.target.files[0] || null;
            }
          }
        }) : _vm._e()];
      }
    }, {
      key: "cell(data_faturamento)",
      fn: function fn(row) {
        return [_c('b-form-input', {
          attrs: {
            "type": "date",
            "size": "sm"
          },
          model: {
            value: row.item.data_faturamento,
            callback: function callback($$v) {
              _vm.$set(row.item, "data_faturamento", $$v);
            },
            expression: "row.item.data_faturamento"
          }
        })];
      }
    }])
  })], 1)], 1), _c('b-modal', {
    attrs: {
      "id": "modalEtiqueta",
      "title": "Deseja imprimir a etiqueta referente a OS?",
      "centered": "",
      "size": "xs"
    },
    on: {
      "show": function show($event) {
        _vm.etiquetaCompleta = false;
      }
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref5) {
        var ok = _ref5.ok,
          cancel = _ref5.cancel;
        return [_c('div', [_c('b-button', {
          ref: "imprimirEtiqueta",
          staticClass: "mr-5",
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": _vm.imprimirEtiqueta
          }
        }, [_vm._v(" Confirmar ")]), _c('b-button', {
          on: {
            "click": function click($event) {
              {
                _vm.actionsStore.updateTable = !_vm.actionsStore.updateTable;
                _vm.actionsStore.selectedRows = [];
                cancel();
              }
            }
          }
        }, [_vm._v(" Cancelar ")])], 1)];
      }
    }])
  }, [_c('label', [_c('p', [_vm._v(" OS a ser impressa número: " + _vm._s((_vm$actionsStore$sele6 = _vm.actionsStore.selectedRows[0]) === null || _vm$actionsStore$sele6 === void 0 ? void 0 : _vm$actionsStore$sele6.numero) + " ")])]), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Informe a quantidade de etiquetas"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "1",
      "max": "10"
    },
    model: {
      value: _vm.repetirEtiqueta,
      callback: function callback($$v) {
        _vm.repetirEtiqueta = $$v;
      },
      expression: "repetirEtiqueta"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "switch": ""
    },
    model: {
      value: _vm.etiquetaCompleta,
      callback: function callback($$v) {
        _vm.etiquetaCompleta = $$v;
      },
      expression: "etiquetaCompleta"
    }
  }, [_vm._v(" Etiqueta completa ")])], 1)], 1), _c('b-modal', {
    attrs: {
      "id": "duplicarOS",
      "title": "Deseja duplicar a OS selecionada?",
      "centered": "",
      "size": "xs"
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref6) {
        var ok = _ref6.ok,
          cancel = _ref6.cancel;
        return [_c('div', [_c('b-button', {
          ref: "doubleOS",
          staticClass: "mr-5",
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": _vm.duplicar
          }
        }, [_vm._v(" Confirmar ")]), _c('b-button', {
          on: {
            "click": function click($event) {
              {
                _vm.actionsStore.updateTable = !_vm.actionsStore.updateTable;
                _vm.actionsStore.selectedRows = [];
                cancel();
              }
            }
          }
        }, [_vm._v(" Cancelar ")])], 1)];
      }
    }])
  }, [_c('label', [_vm._v("OS a ser duplicada "), _c('p', [_vm._v("Número: " + _vm._s((_vm$actionsStore$sele7 = _vm.actionsStore.selectedRows[0]) === null || _vm$actionsStore$sele7 === void 0 ? void 0 : _vm$actionsStore$sele7.numero))])])]), _c('b-modal', {
    attrs: {
      "id": "atualizarOS",
      "title": "Deseja atualizar o status da(s) OS selecionada(s)?",
      "centered": "",
      "size": "xs"
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref7) {
        var ok = _ref7.ok,
          cancel = _ref7.cancel;
        return [_c('div', [_c('b-button', {
          ref: "updateOS",
          staticClass: "mr-5",
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": _vm.atualizarStatus
          }
        }, [_vm._v(" Confirmar ")]), _c('b-button', {
          on: {
            "click": function click($event) {
              {
                _vm.actionsStore.updateTable = !_vm.actionsStore.updateTable;
                _vm.actionsStore.selectedRows = [];
                cancel();
              }
            }
          }
        }, [_vm._v(" Cancelar ")])], 1)];
      }
    }])
  }, [_c('label', [_vm._v("OS(s) para mudar o status "), _c('p', [_vm._v(" Número(s): " + _vm._s(_vm.actionsStore.selectedRows.map(function (os) {
    return os.numero;
  }).join(",")) + " ")])]), _c('b-form-group', {
    attrs: {
      "label": "Selecione o status",
      "label-for": "status"
    }
  }, [_c('VueSelect', {
    ref: "buscarStatus",
    attrs: {
      "filterable": false,
      "options": _vm.osStatus
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.descricao) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.descricao) + " ")])];
      }
    }]),
    model: {
      value: _vm.statusSelected,
      callback: function callback($$v) {
        _vm.statusSelected = $$v;
      },
      expression: "statusSelected"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o status ")])], 2)], 1)], 1), _c('b-modal', {
    attrs: {
      "id": "estornarOSModal",
      "title": "Estornar OS?",
      "size": "md",
      "centered": ""
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref8) {
        var ok = _ref8.ok,
          cancel = _ref8.cancel;
        return [_c('b-button', {
          on: {
            "click": function click($event) {
              return cancel();
            }
          }
        }, [_vm._v(" Cancelar ")]), _c('b-button', {
          ref: "estornar_os",
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": _vm.estornarOS
          }
        }, [_vm._v(" Salvar ")])];
      }
    }])
  }, [_c('div', {
    staticClass: "mx-auto"
  }, [_c('b-form', {
    staticClass: "form"
  }, [_c('b-row', [_c('b-col', [_vm._v(" Deseja estornar a OS número: " + _vm._s((_vm$actionsStore = _vm.actionsStore) === null || _vm$actionsStore === void 0 || (_vm$actionsStore = _vm$actionsStore.selectedRows[0]) === null || _vm$actionsStore === void 0 ? void 0 : _vm$actionsStore.numero) + " ")])], 1)], 1)], 1)]), _c('div', {
    staticClass: "os-status-summary"
  }, [_c('table', {
    staticClass: "os-status-summary-table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Total de OS")]), _c('th', [_vm._v("OS não faturadas")]), _c('th', [_vm._v("OS faturadas")]), _c('th', [_c('b-form-select', {
    staticClass: "os-status-summary-select",
    model: {
      value: _vm.statusResumoSelecionado,
      callback: function callback($$v) {
        _vm.statusResumoSelecionado = $$v;
      },
      expression: "statusResumoSelecionado"
    }
  }, [_c('b-form-select-option', {
    attrs: {
      "value": null,
      "disabled": ""
    }
  }, [_vm._v(" Escolha um status ")]), _vm._l(_vm.osStatus, function (status) {
    return _c('b-form-select-option', {
      key: status.id,
      attrs: {
        "value": status
      }
    }, [_vm._v(" " + _vm._s(status.descricao) + " ")]);
  })], 2)], 1)])]), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "os-status-summary-value"
  }, [_vm._v(" " + _vm._s(_vm.totalOrdensServico) + " ")])]), _c('td', [_c('span', {
    staticClass: "os-status-summary-value"
  }, [_vm._v(" " + _vm._s(_vm.totalOrdensServicoNaoFaturadas) + " ")])]), _c('td', [_c('span', {
    staticClass: "os-status-summary-value"
  }, [_vm._v(" " + _vm._s(_vm.totalOrdensServicoFaturadas) + " ")])]), _c('td', [_vm.statusResumoSelecionado ? _c('span', {
    staticClass: "os-status-summary-value"
  }, [_vm._v(" " + _vm._s(_vm.totalOrdensServicoPorStatus) + " ")]) : _c('span', {
    staticClass: "text-muted font-size-sm"
  }, [_vm._v(" Escolha um status ")])])])])])]), _c('TableApp', {
    ref: "osList",
    attrs: {
      "titulo": "Ordem de Serviço",
      "acaoBtn": "/#/ordensServicos-nova",
      "textoBtn": "Nova OS",
      "api-url": "/ordemservico/lista",
      "fields": _vm.fieldsToShow,
      "classFilterColumn": "numero",
      "perPage": 10,
      "multiselect": true
    },
    scopedSlots: _vm._u([{
      key: "customRow",
      fn: function fn(props) {
        return [props.field == 'numero' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "numero"
          },
          slot: "numero"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [!props.rowData.copia_arquivo && !props.rowData.numero_interno ? _c('div', {
          staticClass: "font-weight-bold"
        }, [_vm._v(" " + _vm._s(props.rowData.numero) + " ")]) : _vm._e(), props.rowData.copia_arquivo && !props.rowData.numero_interno ? _c('div', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.bottom",
            value: 'Ver cópia da OS',
            expression: "'Ver cópia da OS'",
            modifiers: {
              "bottom": true
            }
          }],
          staticClass: "font-weight-bold"
        }, [_c('a', {
          attrs: {
            "href": props.rowData.copia_arquivo,
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(props.rowData.numero))])]) : _vm._e(), props.rowData.copia_arquivo && props.rowData.numero_interno ? _c('div', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.bottom",
            value: 'Ver cópia da OS',
            expression: "'Ver cópia da OS'",
            modifiers: {
              "bottom": true
            }
          }],
          staticClass: "font-weight-bold"
        }, [_c('a', {
          attrs: {
            "href": props.rowData.copia_arquivo,
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(props.rowData.numero_interno))])]) : _vm._e(), !props.rowData.copia_arquivo && props.rowData.numero_interno ? _c('div', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.bottom",
            value: 'Ver cópia da OS',
            expression: "'Ver cópia da OS'",
            modifiers: {
              "bottom": true
            }
          }],
          staticClass: "font-weight-bold"
        }, [_c('a', {
          attrs: {
            "href": props.rowData.copia_arquivo,
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(props.rowData.numero_interno))])]) : _vm._e(), _vm.temAnexo(props.rowData) ? _c('b-button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            value: 'Ver anexos',
            expression: "'Ver anexos'",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "p-0 ml-2",
          staticStyle: {
            "vertical-align": "middle"
          },
          attrs: {
            "variant": "link",
            "size": "sm"
          },
          on: {
            "click": function click($event) {
              $event.stopPropagation();
              return _vm.abrirModalAnexos(props.rowData);
            }
          }
        }, [_c('PaperclipIcon', {
          attrs: {
            "size": 18
          }
        })], 1) : _vm._e()], 1)]) : _vm._e(), props.field == 'cliente' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "cliente"
          },
          slot: "cliente"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          staticClass: "font-weight-bold"
        }, [_vm._v(" " + _vm._s(props.rowData.cliente) + " "), _vm.clienteTelefone(props.rowData) ? _c('br') : _vm._e(), _vm.clienteTelefone(props.rowData) ? _c('small', [_vm._v(" " + _vm._s(_vm.clienteTelefone(props.rowData)) + " ")]) : _vm._e()])])]) : _vm._e(), props.field == 'objeto' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "objeto"
          },
          slot: "objeto"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          staticClass: "font-weight-bold"
        }, [_vm._v(" " + _vm._s(props.rowData.objeto.descricao) + " ")])])]) : _vm._e(), props.field == 'servicos' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "servicos"
          },
          slot: "servicos"
        }, [_c('span', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.top",
            value: _vm.servicosLabel(props.rowData),
            expression: "servicosLabel(props.rowData)",
            modifiers: {
              "hover": true,
              "top": true
            }
          }],
          staticClass: "font-weight-bold os-servicos"
        }, [_vm._v(" " + _vm._s(_vm.servicosLabel(props.rowData)) + " ")])]) : _vm._e(), props.field == 'local_atendimento' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "local_atendimento"
          },
          slot: "local_atendimento"
        }, [_c('span', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.top",
            value: _vm.localAtendimentoLabel(props.rowData),
            expression: "localAtendimentoLabel(props.rowData)",
            modifiers: {
              "hover": true,
              "top": true
            }
          }],
          staticClass: "font-weight-bold os-local-atendimento"
        }, [_vm._v(" " + _vm._s(_vm.localAtendimentoLabel(props.rowData)) + " ")])]) : _vm._e(), props.field == 'identificadores' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "identificadores"
          },
          slot: "identificadores"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          staticClass: "font-weight-bold"
        }, [_vm._v(" " + _vm._s(_vm.formataIdentificadores(props.rowData.identificadores)) + " ")])])]) : _vm._e(), props.field == 'tecnico' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "tecnico"
          },
          slot: "tecnico"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [props.rowData.tecnico ? _c('div', {
          staticClass: "font-weight-bold"
        }, [_vm._v(" " + _vm._s(props.rowData.tecnico.nome) + " ")]) : _c('div', {
          staticClass: "font-weight-bold"
        })])]) : _vm._e(), props.field == 'dataEntrada' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "dataEntrada"
          },
          slot: "dataEntrada"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          staticClass: "font-weight-bold"
        }, [_vm._v(" " + _vm._s(_vm._f("moment")(props.rowData.dataEntrada, "DD/MM/YYYY")) + " ")])])]) : _vm._e(), props.field == 'dataPrevisao' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "dataPrevisao"
          },
          slot: "dataPrevisao"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          staticClass: "font-weight-bold"
        }, [_vm._v(" " + _vm._s(_vm._f("moment")(props.rowData.dataPrevisao, "DD/MM/YYYY")) + " ")])])]) : _vm._e(), props.field == 'proximaRevisao' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "proximaRevisao"
          },
          slot: "proximaRevisao"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [props.rowData.proximaRevisao ? _c('div', {
          staticClass: "font-weight-bold"
        }, [_vm._v(" " + _vm._s(_vm._f("moment")(props.rowData.proximaRevisao, "DD/MM/YYYY")) + " ")]) : _vm._e()])]) : _vm._e(), props.field == 'dataSaida' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "dataSaida"
          },
          slot: "dataSaida"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          staticClass: "font-weight-bold"
        }, [_vm._v(" " + _vm._s(_vm._f("moment")(props.rowData.dataSaida, "DD/MM/YYYY")) + " ")])])]) : _vm._e(), props.field == 'status' ? _c('span', {
          class: _vm.statusOSClass(props.rowData.status),
          attrs: {
            "slot": "status"
          },
          slot: "status"
        }, [_vm._v(" " + _vm._s(_vm.statusOSLabel(props.rowData.status)) + " ")]) : _vm._e(), props.field == 'valorTotal' ? _c('span', {
          staticClass: "text-dark-75 font-weight-bolder d-block font-size-lg",
          attrs: {
            "slot": "valorTotal"
          },
          slot: "valorTotal"
        }, [_vm._v(" R$ " + _vm._s(_vm.numberToReal(props.rowData.valorTotal, 2)) + " ")]) : _vm._e(), props.field == 'actions' ? _c('span', {
          staticClass: "text-dark-75 font-weight-bolder d-block font-size-lg",
          attrs: {
            "slot": "actions"
          },
          slot: "actions"
        }, [_c('div', {
          staticClass: "action-buttons os-action-buttons"
        }, [_c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.bottom",
            value: 'Impressão da OS',
            expression: "'Impressão da OS'",
            modifiers: {
              "bottom": true
            }
          }],
          staticClass: "btn btn-sm btn-info btn-hover-info btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.imprimirOS(props.rowData);
            }
          }
        }, [_c('PdfIcon', {
          attrs: {
            "size": 22
          }
        })], 1), _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.bottom",
            value: 'Imprimir OS para técnico',
            expression: "'Imprimir OS para técnico'",
            modifiers: {
              "bottom": true
            }
          }],
          staticClass: "btn btn-sm btn-warning btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.imprimirOSTecnico(props.rowData);
            }
          }
        }, [_c('PdfIcon', {
          attrs: {
            "size": 22
          }
        })], 1), _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.bottom",
            value: 'Copiar Link',
            expression: "'Copiar Link'",
            modifiers: {
              "hover": true,
              "bottom": true
            }
          }],
          staticClass: "btn btn-sm btn-success btn-hover-success btn-icon mr-2",
          attrs: {
            "placement": "bottom"
          },
          on: {
            "click": function click($event) {
              return _vm.doCopy(props.rowData, props.rowData.id_ordem_servico);
            }
          }
        }, [_c('Link', {
          attrs: {
            "size": 16
          }
        })], 1), props.rowData.status === 1 ? _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip",
            value: 'Deletar OS',
            expression: "'Deletar OS'"
          }],
          staticClass: "btn btn-sm btn-danger btn-hover-danger btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.deleteOS(props.rowData);
            }
          }
        }, [_c('Close', {
          attrs: {
            "size": 20
          }
        })], 1) : _vm._e(), _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.bottom",
            value: 'Encaminhar para o WhatsApp',
            expression: "'Encaminhar para o WhatsApp'",
            modifiers: {
              "hover": true,
              "bottom": true
            }
          }],
          staticClass: "btn btn-sm btn-success btn-hover-success btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.shareToWhatsapp(props.rowData);
            }
          }
        }, [_c('Whatsapp', {
          attrs: {
            "size": 20
          }
        })], 1), _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.bottom",
            value: 'Enviar link por e-mail',
            expression: "'Enviar link por e-mail'",
            modifiers: {
              "hover": true,
              "bottom": true
            }
          }],
          staticClass: "btn btn-sm btn-info btn-hover-info btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.sendToEmailOS(props.rowData);
            }
          }
        }, [_c('Email', {
          attrs: {
            "size": 20
          }
        })], 1), _c('span', {
          staticClass: "os-row-actions-menu"
        }, [_c('b-button-group', {
          staticClass: "os-acoes-dropdown",
          attrs: {
            "size": "sm"
          }
        }, [_c('b-button', {
          staticClass: "os-edit-action",
          attrs: {
            "variant": "info",
            "disabled": props.rowData.status === 3 || props.rowData.status === 11 || props.rowData.status === 12 || props.rowData.status === 14 || props.rowData.status === 5
          },
          on: {
            "click": function click($event) {
              return _vm.editarOS(props.rowData);
            }
          }
        }, [_vm._v(" Editar ")]), _c('b-button', {
          staticClass: "dropdown-toggle dropdown-toggle-split",
          attrs: {
            "id": "os-acoes-".concat(props.rowData.id_ordem_servico),
            "variant": "info",
            "aria-label": "Abrir ações da OS"
          },
          on: {
            "click": function click($event) {
              return _vm.alternarMenuAcoesOS(props.rowData.id_ordem_servico, $event);
            }
          }
        }, [_c('span', {
          staticClass: "sr-only"
        }, [_vm._v("Abrir ações da OS")])])], 1), _c('b-popover', {
          attrs: {
            "target": "os-acoes-".concat(props.rowData.id_ordem_servico),
            "show": _vm.osAcoesAbertaId === props.rowData.id_ordem_servico,
            "triggers": "",
            "placement": "bottom-end",
            "boundary": "viewport",
            "container": "body",
            "custom-class": "os-acoes-popover"
          },
          on: {
            "hidden": function hidden($event) {
              return _vm.fecharMenuAcoesOS(props.rowData.id_ordem_servico);
            }
          }
        }, [_c('div', {
          staticClass: "os-acoes-menu",
          on: {
            "mousedown": function mousedown($event) {
              $event.preventDefault();
            }
          }
        }, [_c('button', {
          staticClass: "dropdown-item",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function click($event) {
              return _vm.executarAcaoDropdownOS(props.rowData, 'atualizarOS');
            }
          }
        }, [_c('b-icon', {
          staticClass: "mr-2",
          attrs: {
            "icon": "arrow-repeat"
          }
        }), _vm._v(" Atualizar status ")], 1), _c('button', {
          staticClass: "dropdown-item",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function click($event) {
              return _vm.executarAcaoDropdownOS(props.rowData, 'duplicarOS');
            }
          }
        }, [_c('b-icon', {
          staticClass: "mr-2",
          attrs: {
            "icon": "files"
          }
        }), _vm._v(" Duplicar OS ")], 1), _c('button', {
          staticClass: "dropdown-item",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function click($event) {
              return _vm.executarAcaoDropdownOS(props.rowData, 'comprovanteEntrega');
            }
          }
        }, [_c('b-icon', {
          staticClass: "mr-2",
          attrs: {
            "icon": "clipboard-check"
          }
        }), _vm._v(" Comprovante de entrega ")], 1), _c('button', {
          staticClass: "dropdown-item",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function click($event) {
              return _vm.executarAcaoDropdownOS(props.rowData, 'modalEtiqueta');
            }
          }
        }, [_c('b-icon', {
          staticClass: "mr-2",
          attrs: {
            "icon": "tag"
          }
        }), _vm._v(" Etiqueta ")], 1), !_vm.store.pafNFCe && props.rowData.status != 5 ? _c('button', {
          staticClass: "dropdown-item",
          attrs: {
            "type": "button",
            "disabled": props.rowData.status == 14
          },
          on: {
            "click": function click($event) {
              return _vm.executarAcaoDropdownOS(props.rowData, 'faturarOS');
            }
          }
        }, [_c('b-icon', {
          staticClass: "mr-2",
          attrs: {
            "icon": "cash-stack"
          }
        }), _vm._v(" Faturar OS ")], 1) : _vm._e(), _c('button', {
          staticClass: "dropdown-item",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function click($event) {
              return _vm.executarAcaoDropdownOS(props.rowData, 'copiaArquivo');
            }
          }
        }, [_c('b-icon', {
          staticClass: "mr-2",
          attrs: {
            "icon": "paperclip"
          }
        }), _vm._v(" Anexar cópia ")], 1), _c('button', {
          staticClass: "dropdown-item",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function click($event) {
              return _vm.executarAcaoDropdownOS(props.rowData, 'dataBaixa');
            }
          }
        }, [_c('b-icon', {
          staticClass: "mr-2",
          attrs: {
            "icon": "calendar-check"
          }
        }), _vm._v(" Data de saída ")], 1), _c('div', {
          staticClass: "dropdown-divider"
        }), _c('button', {
          staticClass: "dropdown-item",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function click($event) {
              return _vm.executarAcaoDropdownOS(props.rowData, 'timeline');
            }
          }
        }, [_c('b-icon', {
          staticClass: "mr-2",
          attrs: {
            "icon": "clock-history"
          }
        }), _vm._v(" Ver timeline ")], 1), props.rowData.status == 14 ? [_c('div', {
          staticClass: "dropdown-divider"
        }), _c('button', {
          staticClass: "dropdown-item",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function click($event) {
              return _vm.executarAcaoDropdownOS(props.rowData, 'imprimirOSFaturada');
            }
          }
        }, [_c('b-icon', {
          staticClass: "mr-2",
          attrs: {
            "icon": "printer"
          }
        }), _vm._v(" Imprimir OS faturada ")], 1), _c('button', {
          staticClass: "dropdown-item text-danger",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function click($event) {
              return _vm.executarAcaoDropdownOS(props.rowData, 'estornarOSModal');
            }
          }
        }, [_c('b-icon', {
          staticClass: "mr-2",
          attrs: {
            "icon": "arrow-counterclockwise"
          }
        }), _vm._v(" Estornar OS ")], 1)] : _vm._e()], 2)])], 1)])]) : _vm._e()];
      }
    }])
  }), _c('SendToWppModal', {
    attrs: {
      "data": _vm.dataToWhatsapp,
      "openModal": _vm.wppOpenModal,
      "module": "os"
    },
    on: {
      "handleOpenModal": function handleOpenModal(openModal) {
        return _vm.wppOpenModal = openModal;
      }
    }
  }), _c('b-modal', {
    attrs: {
      "id": "selectEmailOSModal",
      "title": "Enviar OS por e-mail",
      "size": "md",
      "centered": ""
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref9) {
        var cancel = _ref9.cancel;
        return [_c('b-button', {
          on: {
            "click": function click($event) {
              return cancel();
            }
          }
        }, [_vm._v(" Cancelar ")]), _c('b-button', {
          ref: "enviar-os-email",
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": _vm.enviarEmailOS
          }
        }, [_vm._v(" Enviar ")])];
      }
    }])
  }, [_c('div', {
    staticClass: "mx-auto"
  }, [_vm.userEmailsToSend.length > 0 ? _c('b-form-group', {
    attrs: {
      "label": "E-mail",
      "label-for": "emailOS"
    }
  }, [_c('VueSelect', {
    ref: "emailOSToSend",
    attrs: {
      "filterable": false,
      "options": _vm.userEmailsToSend
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.label || option) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.label || option) + " ")])];
      }
    }], null, false, 775520164),
    model: {
      value: _vm.selectedEmail,
      callback: function callback($$v) {
        _vm.selectedEmail = $$v;
      },
      expression: "selectedEmail"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o e-mail ")])], 2)], 1) : _c('b-form-group', {
    attrs: {
      "id": "selectedEmailOS",
      "label-for": "selectedEmailOS",
      "label": "E-mail"
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.selectedEmail,
      callback: function callback($$v) {
        _vm.selectedEmail = $$v;
      },
      expression: "selectedEmail"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "id": "ccEmailOS",
      "label-for": "ccEmailOS",
      "label": "Cópia para: (opcional)"
    }
  }, [_c('b-form-input', {
    attrs: {
      "autofocus": ""
    },
    model: {
      value: _vm.ccEmail,
      callback: function callback($$v) {
        _vm.ccEmail = $$v;
      },
      expression: "ccEmail"
    }
  })], 1)], 1)]), _c('b-modal', {
    attrs: {
      "id": "modalAnexosOS",
      "title": "Anexos da OS:",
      "centered": "",
      "size": "sm",
      "hide-footer": ""
    }
  }, [_vm.modalAnexosData ? _c('div', [_c('ul', {
    staticClass: "list-unstyled"
  }, [_vm._l(_vm.anexosArray(_vm.modalAnexosData), function (anexo, idx) {
    return _c('li', {
      key: idx
    }, [_c('a', {
      attrs: {
        "href": anexo.url,
        "target": "_blank"
      }
    }, [_vm._v("Anexo " + _vm._s(anexo.num))])]);
  }), _vm.anexosArray(_vm.modalAnexosData).length === 0 ? _c('li', [_vm._v(" Nenhum anexo encontrado. ")]) : _vm._e()], 2)]) : _vm._e()])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };